import BaseModel from 'src/model/base.model';

class TrackingInfoModel extends BaseModel {
  public orderNumber: string;
  public orderDate: string;
  public confirmationNumber: string;
  public shippedFrom: string;
  public shippedMethod: string;
  public trackNumber: string;
  public trackingLink: string | null;
}

export default TrackingInfoModel;
